import moment from 'moment';
import { dayAgo, monthAgo, weekAgo } from '@src/utility/date';

export const OPTIONS = {
  ORDER_STATUS: [
    { label: '결제대기', value: 'PWAIT' },
    { label: '신규주문', value: 'BNEWO' },
    { label: '출고대기', value: 'BRDYS' },
    { label: '배송중', value: 'SPING' },
    { label: '배송완료', value: 'ASCOM' },
  ],
  ORDER_CANCEL_STEP: [
    { value: '1', label: '해당 주문만 취소 처리' },
    { value: '2', label: '주문취소 STEP2' },
    { value: '3', label: '주문취소 STEP3' },
    { value: '4', label: '주문취소 STEP4' },
  ],
  ORDER_CANCEL_REASON: [
    { value: '1', label: '품절' },
    { value: '2', label: '배송지연' },
    { value: '3', label: '취소사유3' },
    { value: '4', label: '취소사유4' },
  ],
  ORDER_SEARCH_COLUMNS: [
    { value: 'order_uid', label: '주문 번호' },
    { value: 'order_items.mall_order_item_no', label: '마켓 주문번호' },
    { value: 'order_people.buyer_name', label: '주문자명' },
    { value: 'order_people.receiver_name', label: '수령자명' },
    { value: 'delivery_company', label: '운송사명' },
  ],
  DELIVERY_DELAY_REASON: [
    { value: '1', label: '상품 준비 중' },
    { value: '2', label: '주문제작' },
    { value: '3', label: '고객요구' },
    { value: '4', label: '기타' },
  ],
  SKU_SEARCH_COLUMNS: [
    { value: 'brand', label: '브랜드명' },
    { value: 'brand_jp', label: '브랜드명(일본어)' },
    { value: 'brand_en', label: '브랜드명(영어)' },
    { value: 'sku_code', label: '옵션 SKU 상품코드' },
    { value: 'name', label: '옵션 SKU 상품명' },
    { value: 'name_jp', label: '옵션 SKU 상품명(일본어)' },
    { value: 'name_en', label: '옵션 SKU 상품명(영어)' },
  ],
  SKU_CARRIER_SEARCH_COLUMNS: [
    { value: 'carrier_id', label: '매칭 운송사' },
    { value: 'carrier_matched', label: '운송사 매칭여부' },
    { value: 'brand', label: '브랜드명' },
    { value: 'brand_jp', label: '브랜드명(일본어)' },
    { value: 'brand_en', label: '브랜드명(영어)' },
    { value: 'sku_code', label: '옵션 SKU 상품코드' },
    { value: 'name', label: '옵션 SKU 상품명' },
    { value: 'name_jp', label: '옵션 SKU 상품명(일본어)' },
    { value: 'name_en', label: '옵션 SKU 상품명(영어)' },
  ],
  SKUSETS_SEARCH_COLUMNS: [
    { value: 'set_code', label: '세트상품코드' },
    { value: 'name', label: '세트상품명' },
  ],
  MARKET_PRODUCTS_COLUMNS: [
    { value: 'name', label: '상품명' },
    { value: 'product_code', label: '상품코드' },
    { value: 'mall_product_code', label: '마켓상품코드' },
    { value: 'brand', label: '브랜드' },
    { value: 'memo', label: '메모' },
  ],
  ORDER_EXCEL_TYPE: [
    { label: '일반', value: '일반' },
    { label: '운송사', value: '운송사' },
    { label: '패킹리스트', value: '패킹리스트' },
    { label: '주문양식', value: '주문양식' },
    { label: '기타', value: '기타' },
  ],
  SAVE_EXCEL_FILE_TYPE: [
    { label: 'xlsx', value: 'xlsx' },
    { label: 'xls', value: 'xls' },
    { label: 'csv', value: 'csv' },
  ],
  EXCEL_COLUMNS: [
    { label: '주문일', value: 'order_at' },
    { label: '묶음번호(마켓)', value: 'mall_pack_no' },
    { label: '상품명', value: 'product_name' },
    { label: '쉬취인명', value: 'receiver_name' },
    { label: 'SKU코드(마켓)', value: 'mall_option_code' },
  ],
  EXCEL_COLUMNS_DIRECTION: [
    { label: '내림차순', value: 'desc' },
    { label: '오름차순', value: 'asc' },
  ],
  USER_ROLES: [
    { label: '시스템관리자', value: 'admin' },
    { label: '기업관리자', value: 'company' },
    { label: '커스텀관리자', value: 'custom' },
  ],
  USER_STATUS: [
    { label: '사용', value: 1 },
    { label: '휴면', value: 0 },
  ],
  USER_WORK_TYPES: [
    { label: '상품', value: 'products' },
    { label: '주문', value: 'order' },
    { label: 'CS', value: 'cs' },
  ],
  USER_WORK_NAMES: [
    { label: '상품가져오기', value: 'get_product' },
    { label: '주문 수집', value: 'get_order' },
    { label: '주문 양식 다운로드', value: 'order_download' },
    { label: 'CS 문의', value: 'cs' },
  ],
  // USER_WORK_STATUS: [
  //   { label: '대기', value: 'op' },
  //   { label: '진행중', value: 'op' },
  //   { label: '완료', value: 'op' },
  //   { label: '오류', value: 'op' },
  // ],
  CONNECTION_LIMIT: [
    { label: '제한 없음', value: 'use' },
    { label: '특정 IP만 접속 허용', value: 'sleep' },
  ],
  COUNTRY: [
    { label: '가나 GH', value: 'gh' },
    { label: '가봉 GA', value: 'ga' },
    { label: '감비아 GM', value: 'gm' },
    { label: 'コートジボワール', value: 'コートジボワール' },
  ],
  CARRIER: [
    { label: 'Lincos', value: 1 },
    { label: 'Shipnergy', value: 2 },
    { label: 'Yunege', value: 3 },
  ],
  CURRENCY: [
    { label: 'USD', value: 'USD' },
    { label: 'KRW', value: 'KRW' },
    { label: 'JPY', value: 'JPY' },
    { label: 'EUR', value: 'EUR' },
    { label: 'CNY', value: 'CNY' },
    { label: 'GPB', value: 'GPB' },
  ],
  MARKET_NAME: [
    { label: 'Qoo10', value: 'Qoo10' },
    { label: 'RAKUTEN', value: 'RAKUTEN' },
    { label: 'paypaymall', value: 'paypaymall' },
    { label: 'shopee', value: 'shopee' },
    { label: '기타', value: '기타' },
  ],
  SALE_STATUS: [
    { label: '판매상태별', value: '판매상태별' },
    { label: '판매상태별', value: '판매상태별' },
    { label: '판매상태별', value: '판매상태별' },
  ],
  PRODUCTS_MAPPING_STATUS: [
    { label: '상품마스터 매핑 여부', value: '상품마스터 매핑 여부' },
    { label: '상품마스터 매핑 여부', value: '상품마스터 매핑 여부' },
    { label: '상품마스터 매핑 여부', value: '상품마스터 매핑 여부' },
  ],
  PER_PAGE_OPTIONS: [
    { label: '50건 씩 보기', value: 50 },
    { label: '100건 씩 보기', value: 100 },
    { label: '200건 씩 보기', value: 200 },
    { label: '500건 씩 보기', value: 500 },
  ],
  CS_TYPE: [
    { label: '상품문의', value: 'P' },
    { label: '배송문의', value: 'S' },
    { label: '주문문의', value: 'O' },
    { label: '취소환불문의', value: 'C' },
    { label: '교환반품문의', value: 'E' },
    { label: '기타문의', value: 'ETC' },
  ],
  CS_STATUS: [
    { label: '문의중', value: 'ING' },
    { label: '확인', value: 'COF' },
    { label: '답변완료', value: 'RPL' },
  ],
  CS_MARKET: [
    { label: 'Qoo10.JP', value: 'Qoo10' },
    { label: 'RAKUTEN', value: 'RAKUTEN' },
    { label: 'Paypaymall', value: 'Paypaymall' },
  ],
  DATE_TYPE: [
    { value: 'created_at', label: '등록일' },
    { value: 'updated_at', label: '수정일' },
    { value: 'expiration_date', label: '판매종료일' },
  ],
  SEARCH_MARKET_PRODUCTS_DATE_TYPES: [
    { value: 'created_at', label: '등록일' },
    { value: 'updated_at', label: '수정일' },
  ],
  OPTION_DATE_TYPE: [
    { value: 'created_at', label: '등록일' },
    { value: 'updated_at', label: '수정일' },
  ],
  OPTION_TYPE: [
    { value: 'option', label: '마켓상품 옵션명' },
    { value: 'market', label: '마켓상품명' },
  ],
  DISPLAY_LEFT_PERIOD: [
    { value: '1', label: '1일전' },
    { value: '2', label: '2일전' },
    { value: '3', label: '3일전' },
  ],
  AVAILABLE_SHIPPING_DATE: [
    { value: 0, label: '일반발송' },
    { value: 1, label: '상품준비일' },
    { value: 2, label: '출시일' },
    { value: 3, label: '당일발송' },
  ],
  PRODUCTION_PLACE_TYPE: [
    { value: '1', label: '국내' },
    { value: '2', label: '해외' },
    { value: '3', label: '기타' },
  ],
  DRUG_TYPE: [
    { value: '', label: '의약품아님' },
    { value: '1C', label: '제1류 의약품' },
    { value: '2C', label: '제2류 의약품' },
    { value: '3C', label: '제3류 의약품' },
    { value: 'D2', label: '지정 제2류 의약품' },
    { value: 'QD', label: '의약외품' },
  ],
  SALES_END_IMMINENT_DATE: [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
  ],
  EXCEPT_CURRENCY: ['JPY', 'USD', 'SGD'],
  DEPOT_SEARCH_COLUMNS: [
    { value: 'name', label: '배송처명' },
    { value: 'contact_name', label: '담당자' },
    { value: 'country', label: '국가' },
  ],
  DEPOT_USE_TYPE: [
    { value: 1, label: '사용중' },
    { value: 0, label: '사용안함' },
  ],
};

const today = moment().format('YYYY-MM-DD');

export const DATE_RANGE = {
  TODAY: { value: [today, today], label: '오늘' },
  YESTERDAY: { value: [dayAgo(1), today], label: '어제' },
  ONE_WEEK: { value: [weekAgo(1), today], label: '일주일' },
  FIFTEEN_DAYS: { value: [dayAgo(15), today], label: '15일' },
  ONE_MONTH: { value: [monthAgo(1), today], label: '1개월' },
  THREE_MONTH: { value: [monthAgo(3), today], label: '3개월' },
};

export const valueToOption = (options, value) => options.find((item) => item.value === value);
